module.exports = __webpack_public_path__ + "img/take-my-hand.d7720686.png";